import { Injectable } from '@angular/core';
import { TradeInstructionsComponent } from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import {getDestinations, orderTypes} from '../trade-instructions.model';
@Injectable({
	providedIn: 'root',
  })
export class NotHeldLayoutSetup {
	notHeldLayoutSetup(shrCnty: boolean, parent: TradeInstructionsComponent) {
		const self = parent;
		const item = self.data;
		const pList = self.algorithmPermissionsObj.algorithmPermissionsList;
		let a = pList.Citadel_TWAP || pList.Citadel_VWAP;
		let b = pList.Virtu_TWAP || pList.Virtu_VWAP;
		const VWAPTWAPPerm = (a || b) ? true : false;
		const permList = self.getFilteredArray(getDestinations(pList), 'permissions', true);
		self.notHeldDestinations = permList;
		self.notHeldDestinationSelected = null;
		// if (dijit.byId("ordIsNotHeld")._getValueAttr() === null) { // sa not sure if needed
		//   dijit.byId("ordIsNotHeld").reset();
		// }

		if (shrCnty) {
			// dijit.byId('notHeldDestination').query = {
			//   id: "AOM_PRINTER"
			// };

			self.notHeldDestinations = permList.filter((entry: any) => (entry.id == "AOM_PRINTER")); //self.getFilteredArray(permList, 'id', 'AOM_PRINTER');
			self.notHeldDestinationSelected = self.notHeldDestinations[0];
			self.notHeldDestinationChanged({value: self.notHeldDestinationSelected});
			self.notHeldDestinationDisabled = false;

		} else if (self.notHeld === null || self.notHeld === false || !VWAPTWAPPerm) {

			self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false;
			if (self.orderTypeSelected) {
				self.expirationTypeDisabled = false;
			}

			//IREBALUX-1338 - Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
			self.orderTypes = self.getFilteredArray(orderTypes, 'trailingStopAvailable', 'TRUE');

			if (!self.notHeld) {
				self.notHeldDestinations = null;
				self.notHeldDestinationSelected = null;
				self.notHeldDestinationDisabled = true;
			} else if (!VWAPTWAPPerm) {
				self.notHeldDestinationSelected = self.getFilteredValue(getDestinations(pList), 'id', 'AOM_PRINTER');
				self.notHeldDestinationChanged({value: self.notHeldDestinationSelected});
				self.notHeldDestinationDisabled = false;
			}
		} else {
			if (VWAPTWAPPerm) {
				self.notHeldDestinations = permList;
				self.notHeldDestinationSelected = null;
			} else {
				self.notHeldDestinations = permList.filter((entry: any) => (entry.id == "AOM_PRINTER"));
				if (self.notHeldDestinations && self.notHeldDestinations.length > 0) {
					self.notHeldDestinationSelected = self.notHeldDestinations[0];
					self.notHeldDestinationChanged({value: self.notHeldDestinationSelected});
				}
			}
			self.notHeldDestinationDisabled = false;
		}
		if (self.actionType == "MultiEdit") { //IREBALUX-3342

			/**Order type dropdown field should only have 2 options available: Market or Limit. As part of the MVP,
			 * we will not allow users to add Stop or Stop Limit order type instructions when editing multiple orders.
			 */
			//IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
			//let destination = this.data ? this.data.notHeldDestination: this.notHeldDestinationSelected.id;
			self.setDestination();

		} else {
			self.trailingStopOrderTypeFilter();
		}
		if (self.notHeld) {
			if (self.notHeldDestinationSelected) {
				self.destinationLayoutSetup(self.notHeldDestinationSelected.id);
			} else {
				self.notHeldDestinationSelected = null;
			}
		}

	}

}
